import { getApm } from 'instrumentation/apm';
import PageApp from 'renderer/PageApp';
import { hydrateClient } from 'client/hydrateClient';
import { WINDOW_DATA_PROPERTY_NAME, PAGE_ROOT_ID } from 'constants/render';
import { logHydrationError } from 'client/logHydrationError';

export const renderPageClient = () => {
  getApm('full-instrumentation');

  const contentRoot = document.getElementById(PAGE_ROOT_ID) as HTMLElement;

  if (!contentRoot) {
    logHydrationError(
      new Error(`Content Renderer: Missing DOM element with ID "${PAGE_ROOT_ID}"`),
      'page',
    );
    return null;
  }

  const { content, config } = window[WINDOW_DATA_PROPERTY_NAME] || {};
  const contentData = content?.[PAGE_ROOT_ID];

  if (!contentData) {
    logHydrationError(
      new Error(`Content Renderer: Missing window data payload for "${PAGE_ROOT_ID}"`),
      'page',
    );
    return null;
  }

  const { componentData, pageData, preloadedData = {} } = contentData;

  if (!pageData) {
    logHydrationError(new Error('Content Renderer: pageData missing for PageApp'), 'page');
    return null;
  }

  return hydrateClient({
    loggerName: 'page',
    appElement: (
      <PageApp
        componentLibraryConfig={{
          ...(config || {}),
          cfDomain: config?.cfDomain ?? '',
        }}
        componentData={componentData || []}
        pageData={pageData}
        preloadedData={preloadedData}
      />
    ),
    contentRoot,
    namespace: document.documentElement.getAttribute('data-cr-content-path')!,
  });
};
